if (!customElements.get('shy-progressive-product-grid')) {
  customElements.define(
    'shy-progressive-product-grid',
    class ShyProgressiveProductGrid extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        const button = this.querySelector('.shy-progressive-products__button');
        const items = Array.from(this.querySelectorAll('#product-grid > .grid__item'));
        const limit = Number.parseInt(this.dataset.initialLimit || '8', 10);

        if (!button || items.length <= limit) return;

        const expandLabel = button.querySelector('[data-expand-label]');
        const collapseLabel = button.querySelector('[data-collapse-label]');

        this.dataset.initialized = 'true';
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') === 'true';
          const nextExpanded = !expanded;

          items.forEach((item, index) => {
            if (index >= limit) item.hidden = !nextExpanded;
          });

          button.setAttribute('aria-expanded', String(nextExpanded));
          if (expandLabel) expandLabel.hidden = nextExpanded;
          if (collapseLabel) collapseLabel.hidden = !nextExpanded;

          if (!nextExpanded) {
            this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    },
  );
}
